// AboutDirectSubmit.jsx

import React from "react";
import "./TourPages.css";
import Footer from "../../components/NonLoggedFooter";
import AboutHero from "../../assets/about-directsubmit.png"
import Navigation from "../components/PublicNavbar";

export default function AboutDirectSubmit() {
  return (
    <>
    <Navigation />
      <section className="tour-hero">
        <img
          src={AboutHero}
          alt="About DirectSubmit"
          className="tour-hero-image"
        />

       {/*  <div className="tour-hero-overlay">
          <h1>About DirectSubmit</h1>
        </div> */}
      </section>

      <section className="tour-container">
        <h2>About Us</h2>

        <p>
         <p> DirectSubmit is a nationwide casting platform built to help talent connect directly with casting professionals and real production opportunities. The platform is trusted by casting directors, producers, and content creators across the entertainment industry.<br /></p>
<p>The company was founded in 2000 by Aaron Seals, who has served as CEO since the beginning. Originally launched as NYCastings.com, the platform focused on supporting the New York entertainment industry — one of the most competitive and influential production markets in the world.<br /></p>
<p>Over time, NYCastings became a respected casting resource used by talent and industry professionals working on major films, television series, Broadway productions, commercials, and live events.<br /></p>
<p>Productions associated with the platform have included major studio films such as <span className="italic">The Wolf of Wall Street, Men in Black 3, Transformers 3, I Am Legend, Sex and the City, The Devil Wears Prada, and War of the Worlds.</span><br /></p>
<p>Television productions have included work connected to series and programs such as <span className="italic">Saturday Night Live, The Daily Show, Law & Order, Gossip Girl, Blue Bloods, Boardwalk Empire, White Collar, 30 Rock, Chappelle’s Show, and American Idol.</span><br /></p>
<p>On Broadway and in New York theatre, productions connected to talent discovery through the platform have included <span className="italic">The Lion King, Wicked, Chicago, Jersey Boys, Rent, A Chorus Line, and Spider-Man: Turn Off the Dark.</span><br /></p>
<p>As film, television, commercial, and digital content production expanded beyond New York, the platform evolved into a nationwide casting resource supporting productions across the United States in major markets including Los Angeles, Atlanta, Miami, Chicago, Las Vegas, Texas, Seattle, and Nashville.<br /></p>
<p>To reflect this growth and broader mission, NYCastings transitioned into DirectSubmit — a modern casting platform built for today’s nationwide, digital-first entertainment industry.<br /></p>
<p>With more than two decades of industry experience and over <b>120,000 casting projects supported</b>, DirectSubmit continues to focus on its core mission:<br /></p>
<p> <b>Direct connection. Real opportunities. Helping talent get booked.</b></p>
        </p>
      </section>

      <Footer />
    </>
  );
}